import api from './api';

// gym-api responses are enveloped as { success, message, data, error } —
// this helper unwraps to the `data` payload for callers.

export async function getMyGymReviews(params = {}) {
  const res = await api.get('/gyms/me/reviews', { params });
  return res.data.data;
}

export async function replyToReview(reviewId, text) {
  const res = await api.patch(`/gyms/me/reviews/${reviewId}/reply`, { text });
  return res.data.data;
}
